export default "__VITE_ASSET__YzQWgLHZ__"